import React from "react";
import { useI18n } from "../contexts/I18nContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { Globe, Check } from "lucide-react";

export default function LanguageToggle() {
  const { lang, setLang, t } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5" data-testid="lang-toggle">
          <Globe className="w-4 h-4" />
          <span className="text-xs font-semibold uppercase">{lang}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-sm">
        <DropdownMenuItem onClick={() => setLang("en")} data-testid="lang-en">
          <Check className={`w-3.5 h-3.5 mr-2 ${lang==='en'?'opacity-100':'opacity-0'}`} />
          {t("lang.en")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLang("fr")} data-testid="lang-fr">
          <Check className={`w-3.5 h-3.5 mr-2 ${lang==='fr'?'opacity-100':'opacity-0'}`} />
          {t("lang.fr")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
